import styled from "styled-components";
import { devices, vars } from "../../Theme.css";

export const SwipeableNotificationWrap = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  @media ${devices.max_sm} {
    width: 100vw;
  }
`;

export const NotificationMenuList = styled.div`
  padding: 8px 0;
  border-radius: 16px;
  min-width: 420px;
  max-width: 460px;
  overflow: hidden;

  @media ${devices.max_sm} {
    min-width: 100vw;
    max-width: 100vw;
    border-radius: 0;
  }
`;

export const NotificationScrollArea = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 60vh;
  overscroll-behavior: contain;

  @media ${devices.max_sm} {
    max-height: 80vh;
  }

  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.12) transparent;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.12);
    border-radius: 999px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.2);
  }
`;

export const SwipeableContent = styled.div`
  position: relative;
  width: 100%;
  transition: transform 0.2s ease-out;
  background: inherit;
  z-index: 1;
`;

export const SwipeDeleteStrip = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 64px;
  background: ${vars.color.lightRed};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  z-index: 0;
`;

export const MenuItem = styled.div`
  padding: 12px 20px;
  cursor: pointer;
  transition: box-shadow 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);

  &:hover {
    box-shadow: inset 0 0 0 9999px rgba(0, 0, 0, 0.04);
  }

  &:last-child {
    border-bottom: none;
  }


  @media ${devices.max_sm} {
    width: 100vw;
  }

  .row {
    min-width: 100%;
    max-width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }

  .message {
    width: 80%;
  }

  .icons {
    min-width: 72px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .time-ago {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    font-size: 12px;
    color: #aaa;
    font-weight: bold;
  } 
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;
  &:hover {
    background: rgba(238, 90, 41, 0.08);
    border-radius: 50%;
  }
`;

export const ReactionContainer = styled.div`
  svg {
    width: 20px;
    height: 20px;
  }
`;
